import { render, staticRenderFns } from "./organization-physical-archive-view.vue?vue&type=template&id=465bfb69"
import script from "./organization-physical-archive-view.vue?vue&type=script&lang=js"
export * from "./organization-physical-archive-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports